import { Grid, Paper } from "@mui/material";
import { GridApi } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useEffect } from "react";
import { BilletHistory } from "../models/BilletsHistory";
import { useTableData } from "./hooks";
import { defaultColDef, defaultGridOptions } from "@/setup/ag-grid/mesf-theme";
import { useResize } from "@/utils/useResize";
import { getResponsiveTableStyles } from "@/utils/responsive-utils";

type Props = {
  isLoading: boolean;
  rows: BilletHistory[];
  refreshData: () => void;
  setGridApi: (gridApi: GridApi | null) => void;
};

export const BilletsYardTable = ({
  isLoading,
  rows,
  refreshData,
  setGridApi,
}: Props) => {
  const { columns } = useTableData();
  const { width, height } = useResize();
  const tableStyles = getResponsiveTableStyles(width, height);

  useEffect(() => {
    refreshData();
  }, []);

  return (
    <>
      <Grid container>
        <Grid
          item
          component={Paper}
          elevation={3}
          md={12}
          xs={12}
          style={tableStyles}
        >
          <AgGridReact<BilletHistory>
            loading={isLoading}
            onGridReady={(params) => setGridApi(params.api)}
            rowData={rows}
            columnDefs={columns}
            defaultColDef={defaultColDef}
            {...defaultGridOptions}
          />
        </Grid>
      </Grid>
    </>
  );
};
